export const TOAST_TIME_LIMIT = 6500;
export const TOAST_CLOSE_ANIMATION_DURATION = 300;
